import { MARKET_POSITION } from '@/constants/marketBackendEnums'

export default {
  PLAY_MONEY: 'play_money',
  REAL_MONEY: 'real_money',
  CANONICAL_CURRENCY: 'USDC',
  IDLE: 'idle',
  LOADING: 'loading',
  COMPLETE: 'complete',
  ERROR: 'error',
  SAVING: 'saving',
  REAL_MONEY_PLACEHOLDER: 'REAL_MONEY_PLACEHOLDER',
  position: {
    SHORT: MARKET_POSITION.SHORT,
    LONG: MARKET_POSITION.LONG,
  },
}
